import React from 'react';
import { List } from 'semantic-ui-react'

import TitDer from '../../../components/funcionales/titder';

// import EstilosHome from '../../css/home.css';

const Dato = ({styles, elemento}) => {
  return(
    <div>
      <div className="right floated content">
        <p style={styles.elemLis_2}>{elemento.codigoCiudad}: {elemento.nombreCiudad} ={">"} {elemento.codigoZona}: {elemento.nombreZona}</p>
      </div>
      <div className="floated content">
        <p style={styles.elemLis_1} className="header">{elemento.codigoBarrio} ={">"} {elemento.nombreBarrio}</p>
      </div>
    </div>
  )};

const DetalleNivel1 = ({styles, elemento, handleClickidLista}) => {
  return (
    <div className="ui middle aligned animated celled link list" style={styles.listaDer}>
      <div className="item">
        <List.Item onClick={(ev)=>handleClickidLista(ev, elemento)}>
            <List.Header>
                <div className="floated content" style={styles.subElemLis_1}>
                    <a className="header"><Dato styles={styles} elemento={elemento}/></a>
                </div>
            </List.Header>
        </List.Item>
      </div>
    </div>
  )
};

const Lista = ({styles, list, handleClickidLista}) => {
  const nivel1Detalle = list.map((elemento, i) => <DetalleNivel1 styles={styles} handleClickidLista={handleClickidLista} elemento={elemento} key={i} />);
  return(
    <div>
      {nivel1Detalle}
    </div>
  )
};

const DirBarr2 = ({autorizacUA, styles, handleClick, list, handleClickidLista}) => {
    const lista = []
    list.forEach((elemento, _id) => {
        if(elemento.ciudades.length>0){
            elemento.ciudades.forEach((elemento1, i) => {
                if(elemento1.zonas.length>0){
                    elemento1.zonas.forEach((elemento2, ii) => {
                        if(elemento2.barrios.length>0){
                            elemento2.barrios.forEach((elemento3, ii) => {
                                if(elemento3.codigoBarrio!==null){
                                  // console.log(elemento3)
                                    lista.push({_id: elemento._id, codigoDpto: elemento.codigoDpto, codigoCiudad: elemento1.codigoCiudad,
                                      nombreCiudad: elemento1.nombreCiudad, codigoZona: elemento2.codigoZona,
                                      nombreZona: elemento2.nombreZona, codigoBarrio: elemento3.codigoBarrio,
                                      nombreBarrio: elemento3.nombreBarrio,
                                      descrRecursoT: elemento3.descrRecursoT?elemento3.descrRecursoT:"",
                                      numeroDocumT: elemento3.numeroDocumT?elemento3.numeroDocumT:"",
                                      codigoTipoDocT: elemento3.codigoTipoDocT?elemento3.codigoTipoDocT:"",
                                      descrRecursoR: elemento3.descrRecursoR?elemento3.descrRecursoR:"",
                                      numeroDocumR: elemento3.numeroDocumR?elemento3.numeroDocumR:"",
                                      codigoTipoDocR: elemento3.codigoTipoDocR?elemento3.codigoTipoDocR:"",
                                    })
                                }
                            })
                        }
                    })
                }
            })
        }
    })

    function ordenarAsc(array, campo) {
        array.sort(function (a, b) {
           return a[campo] > b[campo];
        });
     }
     ordenarAsc(lista, 'codigoBarrio')

     const a01051501 = autorizacUA.findIndex( autorizac => autorizac === "01051501" );

    return (
    <div>
      <List selection>
      <TitDer list={lista} textBoton1="Barrios" btnNuevo={a01051501!==-1?"SI":"NO"} styles={styles} handleClick={handleClick} />

      <Lista list={lista} styles={styles} handleClickidLista={handleClickidLista}/>
      </List>
    </div>
  )
};

export default DirBarr2
